import { render, staticRenderFns } from "./RemDtList .vue?vue&type=template&id=5c2f9a1f&scoped=true&"
import script from "./RemDtList .vue?vue&type=script&lang=js&"
export * from "./RemDtList .vue?vue&type=script&lang=js&"
import style0 from "./RemDtList .vue?vue&type=style&index=0&id=5c2f9a1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f9a1f",
  null
  
)

export default component.exports